import * as React from 'react'
import { useHistory } from 'react-router'
import Page from '../../layout/Page'
import Container from '../../layout/Container'
import { SubmitButton } from '../../../styles/components/buttons'
import { getUrlWithSalonGuid } from '../../../utils/urlParams'
import { RouteType } from '../../../types/routes'

interface ErrorPageProps {
  errors: string
  callback?: () => void
}

export const ErrorPage: React.FC<ErrorPageProps> = ({ errors, callback }) => {
  const { push: navigate } = useHistory()

  const handleGoBack = () => {
    if (callback) {
      callback()
    }
    navigate(getUrlWithSalonGuid(RouteType.Home))
  }

  return (
    <Page>
      <Container>
        <h1>Etwas ist schief gelaufen</h1>
        <p>{errors}</p>
        <SubmitButton onClick={handleGoBack}>Home</SubmitButton>
      </Container>
    </Page>
  )
}
